import {
    Loader as GoogleMapsLoader,
} from '@googlemaps/js-api-loader'

import {
    Client
} from "@googlemaps/google-maps-services-js";

import distanceInMiles from "@/helpers/distance/distance-in-miles.js";

class GoogleMaps {
    constructor() {
        this.googleMapsLoader = new GoogleMapsLoader({
            apiKey: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
            version: "weekly",
            libraries: ["places"]
        });
        (async () => {
            try {
                if (!window.google) {
                    await this.loader()
                } else return true
            } catch (error) {
                console.log(error);
            }
        })();
    }
    async loader() {
        try {
            if (!window.google) {
                await this.googleMapsLoader.load()
            } else return true
        } catch (error) {
            console.log(error);
        }
    }
    async getDistanceMatrix(service, data) {
        return new Promise((resolve, reject) => {
            service.getDistanceMatrix(data, (response, status) => {
                if (status === 'OK') {
                    resolve(response)
                } else {
                    reject(response);
                }
            })
        })
    }
    async getDistance(start, end) {
        console.log('=============== LOAD DISTANCE FROM GOOGLE ================')
        try {
            if (!window.google) {
                await this.loader()
            }
            const origin = new window.google.maps.LatLng(start.lat, start.lng);
            let destinationArray = []
            end.forEach(element => {
                destinationArray.push(new window.google.maps.LatLng(element.lat, element.lng))
            });

            const service = new window.google.maps.DistanceMatrixService();

            const result = await this.getDistanceMatrix(
                service, {
                    origins: [origin],
                    destinations: destinationArray,
                    travelMode: 'DRIVING'
                }
            )
            if (process.env.VUE_APP_REGION === 'US') {
                const distancesInMiles = result.rows[0].elements.map(element => {
                    
                   if(!element.distance){ 
                        return 0;
                    }
                    // Overwrite the `distance.text` with the distance in miles
                    element.distance.text = distanceInMiles(element.distance.value);
                
                    return element;
                });
                let elementArray = [
                    {
                        elements: distancesInMiles
                        
                    }
                ];

                return elementArray;
            }else{
                return result.rows;
            }
        
        
        } catch (error) {
            console.log(error);
        }
    }
    async getTimeZone(location) {
        try {
            if (!window.google) {
                await this.loader()
            }
            const client = new Client({});

            return await client.timezone({
                    params: {
                        location: location,
                        timestamp: new Date(),
                        key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
                    },
                    timeout: 1000
                })
                .then(r => {
                    console.log(r.data);
                    return r.data
                })
                .catch(e => {
                    console.log(e);
                });
        } catch (error) {
            console.log(error);
        }
    }
}

export default {
    install(app) {
        console.log("🚀 ~ install ~ app:", app)
        app.config.globalProperties.googleMaps = new GoogleMaps();
        app.provide('googleMaps', app.config.globalProperties.googleMaps)
    }
};